import { Col, Row } from 'antd';
export const PageParameterHeader = ({
  selectors
}) => <Row gutter={[16, 8]} justify="start" align="middle" className="page-parameter-header" data-sentry-element="Row" data-sentry-component="PageParameterHeader" data-sentry-source-file="SectionHeader.jsx">
    {selectors?.map((item, index) => <Col key={index}>{item}</Col>)}
  </Row>;
const SectionHeader = ({
  children,
  title,
  extra
}) => <Row justify="space-between" style={{
  marginTop: 15,
  marginBottom: 15,
  paddingLeft: 15
}} gutter={[8, 8]} data-sentry-element="Row" data-sentry-component="SectionHeader" data-sentry-source-file="SectionHeader.jsx">
    {title && <Col>
          <span className="section-header-title">{title}</span>
      </Col>}
    <Col style={{
    textAlign: "right"
  }} data-sentry-element="Col" data-sentry-source-file="SectionHeader.jsx">
      {children}
    </Col>
    {extra && <Col className="section-extra">
        <div>{extra}</div>
      </Col>}
  </Row>;
export default SectionHeader;